import { FormControl, FormErrorMessage, Radio, RadioGroup, Spinner, Stack } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { Select } from 'chakra-react-select'

import { FormLabel } from '../../components/FormLabel'
import { RadioIconGroup } from '../../components/RadioIconGroup'
import { RadioStack } from '../../components/RadioStack'
import { RadioIcon } from '../../components/RadioIcon'
import { useSelections } from '../../hooks'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { InsuranceParamsTravelDto, Item } from 'BrokerTsLib/src/dtos'

export const DestinationSelector = () => {
  const { control, getValues, setValue, watch, register, formState: { errors } } = useFormContext<InsuranceParamsTravelDto>()
  const { data: dataDestination, isLoading: isLoadingDestination, isFetching: isFetchingDestination } = useSelections(SelectionType.TravelDestination)
  const { data: dataEuropeDestination, isLoading: isLoadingEuropeDestination, isFetching: isFetchingEuropeDestination } = useSelections(SelectionType.TravelDestEuropeCountry)

  const isContracted = !!getValues('generalParams.contractNumber')

  const destinationId = watch('travel.destination')

  const destinationEuCountryId = getValues('travel.destinationEuropeCountry')

  let sortedEuDestinations: Item[] = []
  if (dataEuropeDestination && !isLoadingEuropeDestination && !isFetchingEuropeDestination) {
    sortedEuDestinations = dataEuropeDestination.data
    sortedEuDestinations.sort((a, b) => a.name.localeCompare(b.name))
  }

  let defaultDestination = null;
  if (destinationEuCountryId && dataEuropeDestination && !isLoadingEuropeDestination && !isFetchingEuropeDestination) {
    const destData = dataEuropeDestination.data.find(item => item.id == destinationEuCountryId);
    if (destData) {
      defaultDestination = {
        label: destData.name,
        value: destData.id
      }
    }
  }

  return (
    <>
      <FormControl isRequired isInvalid={!!errors.travel?.destination}>
        <Stack direction={'row'}>
          <FormLabel tooltip='Vyberte destinaci klientova pobytu'>Destinace</FormLabel>
          {(isFetchingDestination || isLoadingDestination) && <Spinner />}
        </Stack>


        <RadioIconGroup control={control} name="travel.destination" isDisabled={isContracted}>
          <RadioStack
            sx={{ gridTemplateColumns: 'repeat(4, minmax(10rem, 1fr))' }}
            labelsx={{ fontWeight: 'medium' }}
            inputlabelwrappersx={{
              display: 'grid',
              alignItems: 'center'
            }}>

            {dataDestination?.data.map((item) => {
              let icon
              switch (item.id) {
                case Selection.TravelDestinationEurope:
                  icon = 'europe'
                  break;

                case Selection.TravelDestinationWorldWithoutNorthAmerica:
                  icon = 'world-no-us-can'
                  break;

                case Selection.TravelDestinationWorld:
                  icon = 'world'
                  break;

                case Selection.TravelDestinationCzech:
                  icon = 'cs'
                  break;
              }

              return (
                <RadioIcon value={item.id.toString()} key={item.id} icon={icon} iconSize="48px">
                  {item.description}
                </RadioIcon>
              )
            })}
          </RadioStack>
        </RadioIconGroup>

        {errors.travel?.destination && <FormErrorMessage>{errors.travel.destination.message}</FormErrorMessage>}
      </FormControl>

      {
        destinationId == Selection.TravelDestinationEurope && (
          <FormControl isRequired isInvalid={!!errors.travel?.destinationEuropeCountry}>
            <Stack direction={'row'}>
              <FormLabel tooltip='Vyberte destinaci klientova pobytu'>Cílová destinace</FormLabel>
              {(isFetchingEuropeDestination || isLoadingEuropeDestination) && <Spinner />}
            </Stack>

            {dataEuropeDestination && !isLoadingEuropeDestination && !isFetchingEuropeDestination &&
              <Select
                name="travel.destinationEuropeCountry"
                placeholder="Vyberte zemi..."
                isDisabled={isContracted}
                options={sortedEuDestinations.map((country) => ({
                  label: country.name,
                  value: country.id
                }))}
                chakraStyles={{
                  menu: (provided) => ({ ...provided, zIndex: 3 }),
                }}
                onChange={(value) => {
                  setValue('travel.destinationEuropeCountry', value?.value)
                }}
                defaultValue={defaultDestination}
              />
            }

            {errors.travel?.destinationEuropeCountry && <FormErrorMessage>{errors.travel.destinationEuropeCountry.message}</FormErrorMessage>}
          </FormControl>
        )
      }
    </>
  )
}